'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';
import SplitText from 'SplitText';
import dispatcher from '../dispatcher';



export class CareerView extends HTMLButtonElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._option = this.dataset.option;
  }
  connectedCallback() {

    setTimeout(() => {
      this._scrollObject = document.querySelector('.careerForm');
      this._select = document.querySelector('.careerSelect');

      if (!this._option || !this._scrollObject || !this._select) {
        console.warn('Нет data-option или .careerForm или .careerSelect');
      }

      this.addEventListener('click', () => {
        this._select.value = this._option;

        dispatcher.dispatch({
          type: 'scroll-to',
          elem: this._scrollObject
        })
      })
    })
  }
  disconnectedCallback() {
  }
}


window.customElements.define('career-view', CareerView, {extends: 'button'});